import * as angular from 'angular';

// component to display a result count as well a cancel button (X) with a binding function
// e.g. X 10 Result(s)
// @label: optional string

export class ResultsBreadcrumbCtrl {
  label: string;
  resultCount: number;
  notifyCancel: any;

  constructor() {
    'ngInject';
  }

  onClickCancel = this.notifyCancel;
}

export const AptResultsBreadcrumbComponent = {
  bindings: {
    label: '@', // default Results(s)
    resultCount: '<',
    notifyCancel: '&'
  },
  controller: ResultsBreadcrumbCtrl,
  template: `<div>
               <cancel-button tabindex="0" data-test-select="cancel-button" aria-label="clear search results" ng-click="$ctrl.onClickCancel()"></cancel-button>
               <strong data-test-selector="result-count"> {{$ctrl.resultCount}} </strong>
               <span data-test-selector="label">{{ $ctrl.label || 'Result(s)' }}</span>
             </div>`
};
